import React from "react";

export default function Card({ children, className = "", padding = true, ...props }) {
  return (
    <div
      className={`bg-white rounded-2xl border border-gray-100 ${padding ? "p-3.5" : "overflow-hidden"} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <p className={`text-[10px] font-bold text-gray-400 uppercase tracking-[0.7px] mb-2 ${className}`}>
      {children}
    </p>
  );
}
